import { Component, OnInit, Input, Output, EventEmitter, inject } from '@angular/core'
import { BreakpointService } from '@lib/master-detail'
import { IconNamesEnum } from 'ngx-bootstrap-icons'
import { Article } from 'src/app/state'
import { BaseDisplayComponent } from '../display-component-base/display-component-base'
import { DatePipe } from '@angular/common'

@Component({
    selector: 'app-list-item',
    templateUrl: './list-item.component.html',
    styleUrls: ['./list-item.component.scss'],
    imports: [DatePipe]
})
export class ListItemComponent extends BaseDisplayComponent {
  breakpointService = inject(BreakpointService)



  @Input() public isSelected = false
  @Input() public article: Article | undefined
  @Input() public dateFormat: string = 'shortTime'
  @Input() public showAttributes: boolean = true
  @Input() public showDescription: boolean = true
  @Input() public heading: string = 'h5'
  @Output() public attribute = new EventEmitter<any>()

  public iconNames = IconNamesEnum

  constructor() {
    super()
  }
}
